<template>
  <div class="text-center">
    <b-spinner
        v-if="currentProp('module') === 'spinner'"
        small
        :variant="currentProp('variant')"
        style="width: 3rem; height: 3rem;"
    />
    <!--    TODO add font awsome-->
    <b-icon
        v-else
        :icon="currentProp('icon')"
        :font-scale="currentProp('scale')"
        :animation="currentProp('animation')"
        :variant="currentProp('variant')"
    />
    <p class="m-0">{{ currentProp('text') }}</p>
  </div>
</template>

<script>
export default {
  name   : "mutableIcon",
  props  : {
    icons  : Array, // {Icon, Scale, Animation, Variant, Status}
    current: Number // Current Status
    //TODO validator
  },
  methods: {
    currentProp(prop, defaultValue = "") {
      const {icons, current} = this.$props
      return getElem(icons, (icon) => icon.status === current, {[prop]: defaultValue})[prop]
    },
    toSize() {
      const x = this.currentProp('scale')
      return `width: ${x}rem; height: ${x}rem;`
    }
  }
}

function getElem(array, filter, emptyElem = null) {
  if (!array.length) return emptyElem
  for (let i = 0; i < array.length; i++) {
    if (filter(array[i], i, array)) {
      return array[i]
    }
  }
  return emptyElem
}
</script>

<style scoped>

</style>